import { render, staticRenderFns } from "./daftarJurnal.vue?vue&type=template&id=5c777ef4&"
import script from "./daftarJurnal.vue?vue&type=script&lang=js&"
export * from "./daftarJurnal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports